// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1grAn","title":"Header_title__sRmhr","left":"Header_left__ICCnZ","clinicName":"Header_clinicName__10AF6"};